export default __webpack_public_path__ + "static/media/passwordPeek.851eceb6.svg";